var _style, _circle, _path, _rect, _rect2, _path2, _path3, _text, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPagomovil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 233.2",
    style: {
      enableBackground: "new 0 0 1500 233.2"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#05D5D2;}\r\n\t.st1{fill:#006FB9;}\r\n\t.st2{fill:#FBFFFE;}\r\n\t.st3{fill:#0071B7;}\r\n\t.st4{fill:#046FB8;}\r\n\t.st5{fill:none;stroke:#E8FFFF;stroke-width:6.486;stroke-miterlimit:10;}\r\n\t.st6{font-family:'Gotham-Black';}\r\n\t.st7{font-size:174.3562px;}\r\n\t.st8{fill:#FAFCFB;stroke:#016EC1;stroke-width:3.798;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 157.7,
    cy: 121.8,
    r: 98
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.9,196.9h-60.4c-7.3,0-13.2-5.9-13.2-13.2V60c0-7.3,5.9-13.2,13.2-13.2h60.4c7.3,0,13.2,5.9,13.2,13.2 v123.7C201.2,191,195.2,196.9,187.9,196.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 121.8,
    y: 61.7,
    className: "st3",
    width: 71.9,
    height: 100.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 50.8,
    className: "st4",
    width: 23.4,
    height: 5.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M132.2,115.9c0,0,22.8-25.8,45.6,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M139.5,123.9c0,0,15.4-19.5,30.9,0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 272.7911 182.4633)",
    className: "st1 st6 st7"
  }, "PAGO M\xD3VIL")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M148.1,161.2v-37.6c0-3.2,1.7-6.3,4.7-7.7c1.9-0.9,4.1-1.2,6.5,0.3c2.4,1.4,3.7,4.1,3.7,6.9v19 c0,0,13.7-0.6,24.5,4.8c3.8,1.9,6.2,5.9,6.2,10.2l0,19.9c0,1.4-0.3,2.8-0.9,4.1l-3.1,6.9l0.6,17.9h-46.2c0,0,0-18.5,0-18.5 c0-2.4-5.8-8.3-7.3-10.4c-3.2-4.5-11.1-15.2-6.6-20.9c2.5-3.2,8-3.2,11.3-1.4C143.1,155.5,148.1,159.2,148.1,161.2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPagomovil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pagomovil.c09737b3ed71c3d2e6c0e7785664c124.svg";